import { render } from "./B2bTableTaxes.vue?vue&type=template&id=2ebd8509&scoped=true&lang=pug"
import script from "./B2bTableTaxes.vue?vue&type=script&lang=js"
export * from "./B2bTableTaxes.vue?vue&type=script&lang=js"

import "./B2bTableTaxes.vue?vue&type=style&index=0&id=2ebd8509&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebd8509"]])

export default __exports__